import { render, staticRenderFns } from "./InvoiceBookOther.vue?vue&type=template&id=88834602"
import script from "./InvoiceBookOther.vue?vue&type=script&lang=js"
export * from "./InvoiceBookOther.vue?vue&type=script&lang=js"
import style0 from "./InvoiceBookOther.vue?vue&type=style&index=0&id=88834602&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports